import dayjs from 'dayjs'

export default (format, time) => {
  if(!format || !time) return false
  const formatMap = new Map([
    ['regular','YYYY年MM月DD日']
  ])
  return dayjs(time).format(formatMap.get(format))
}